module.exports = __webpack_public_path__ + "img/bill-murray-painting.bdb7b671.jpg";